import React, { useState, useEffect, useMemo } from "react";

import { buildStyles, CircularProgressbar } from "react-circular-progressbar";

import { Typography } from "clearsense-ui/components";

import { CHART_STYLE } from "./constants";

const AnimatedChart = ({ value, parameter }) => {
  const [percentage, setPercentage] = useState(0);

  const computedStyles = useMemo(() => buildStyles({ ...CHART_STYLE }), []);

  useEffect(() => {
    setPercentage((value * 100).toFixed(2));
  }, [value]);

  return (
    <div className="flex flex-col items-center justify-center space-y-2 text-center">
      <CircularProgressbar
        value={percentage}
        text={`${percentage}%`}
        styles={computedStyles}
        background={false}
        className="w-24 h-24 lg:w-20 lg:h-20 xl:w-28 xl:h-28"
      />
      <Typography style="h4">{parameter}</Typography>
    </div>
  );
};

export default AnimatedChart;
